/**!SECTION
 *  este campo de texto recibe un texto que permite ocultar filas que no conicidan en mi lista
 */
$(document).ready(function () {
  // Evento para capturar el cambio en el input de filtro
  $(document).on("input", ".search-mi-lista", function () {
    let context = jQuery(this).closest(".mylist");
    var filtro = $(this).val().toLowerCase(); // Obtener el valor del input en minúsculas
    console.log("search list:");
    console.log(filtro);
    
    //jQuery(".input-filter-list", context).val("").trigger("keyup");
    // Filtrar las filas de la tabla
    $(" .milista-element", context).filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(filtro) > -1);
    });
  });
});
